import { createFileRoute } from "@tanstack/react-router";
import { TestDesignSystem } from "@/pages/design-system/TestDesignSystem";

export const Route = createFileRoute("/demo/design-system/tests/")({
  component: TestDesignSystem,
});
